export const moduleFields={
  matters:[['client','اسم العميل','text'],['court','المحكمة أو الجهة','text'],['caseType','نوع القضية','text'],['counterparty','الطرف المقابل','text'],['counterpartyIdentity','هوية الطرف المقابل أو سجله','text'],['courtCaseNumber','رقم القضية لدى الجهة','text'],['judicialCircuit','الدائرة القضائية','text'],['powerOfAttorney','رقم الوكالة','text']],
  clients:[['email','البريد الإلكتروني','email'],['phone','رقم الجوال','tel'],['identity','رقم الهوية أو السجل','text']],
  contracts:[['counterparty','الطرف المقابل','text'],['startDate','تاريخ البداية','date'],['endDate','تاريخ الانتهاء','date'],['value','قيمة العقد','number']],
  requests:[['requester','مقدم الطلب','text'],['priority','الأولوية','select:عادية|عالية|عاجلة'],['dueAt','تاريخ الاستحقاق','datetime-local']],
  risks:[['likelihood','الاحتمالية','select:منخفضة|متوسطة|مرتفعة'],['impact','الأثر','select:منخفض|متوسط|مرتفع'],['mitigation','إجراء المعالجة','text']],
  outsideCounsel:[['contact','جهة الاتصال','text'],['email','البريد الإلكتروني','email'],['phone','رقم الجوال','tel']],
  tasks:[['dueAt','تاريخ الاستحقاق','datetime-local'],['reminderMinutes','التذكير المسبق','select:60|1440|4320|10080']],
  deadlines:[['dueAt','التاريخ والوقت','datetime-local'],['assignee','المسؤول','text'],['relatedReference','مرجع القضية','text'],['reminderMinutes','التذكير المسبق','select:60|1440|4320|10080']]
};

export function filterRecords(records,query){
  const needle=String(query||'').trim().toLocaleLowerCase('ar');
  if(!needle)return records;
  return records.filter(item=>[item.title,item.name,item.reference,item.status,item.notes,...Object.values(item.metadata||{})].some(value=>String(value??'').toLocaleLowerCase('ar').includes(needle)));
}

export function deadlineReminders(records,now=new Date()){
  const current=now.getTime();
  return records.flatMap(item=>{
    const due=new Date(item.metadata?.dueAt||'');
    if(Number.isNaN(due.getTime())||item.status==='مكتمل')return[];
    const minutes=Number(item.metadata?.reminderMinutes);
    if(!Number.isFinite(minutes)||minutes<0)return[];
    const reminderAt=due.getTime()-minutes*60000;
    if(current<reminderAt)return[];
    return [{id:`deadline-${item.id}`,type:'deadline',title:current>due.getTime()?'موعد متأخر':'تذكير بموعد قانوني',body:item.title||'موعد قانوني',createdAt:new Date(reminderAt).toISOString(),readAt:null,local:true}];
  }).sort((a,b)=>new Date(a.createdAt)-new Date(b.createdAt));
}

export function metadataFromForm(form,module){
  return Object.fromEntries((moduleFields[module]||[]).map(([name])=>[name,String(form.elements[name]?.value||'').trim()]).filter(([,value])=>value!==''));
}
